<template>
  <div>
    <div v-if="tabs" class="flex">
      <router-link
        :to="{ name: routeMine, query: $route.query }"
        class="py-2 rounded text-black text-center hover:text-blue-500 flex-1"
        :class="{ 'bg-white font-semibold': $route.name == routeMine }"
        replace
      >Mijn</router-link>
      <router-link
        :to="{ name: routeAll, query: $route.query }"
        class="py-2 rounded text-black text-center hover:text-blue-500 flex-1"
        :class="{ 'bg-white font-semibold': $route.name == routeAll }"
        replace
      >Team</router-link>
    </div>
    <template v-else>
      <router-link
        :to="{ name: showingMine ? routeAll : routeMine, query: $route.query }"
        class="text-gray-600 hover:text-gray-900 block"
        v-tooltip.right="showingMine ? 'Toon alle' : 'Toon mijn'"
      >
        <BaseIcon name="shuffle" size="22" />
      </router-link>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    tabs: Boolean
  },

  computed: {
    showingMine() {
      return this.$route.name.includes(".mine");
    },
    routeAll() {
      return this.$route.name.replace(".mine", "");
    },
    routeMine() {
      if (this.showingMine) {
        return this.$route.name;
      } else {
        return `${this.$route.name}.mine`;
      }
    }
  }
};
</script>
